import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editTaskStatus(request: Boundaries["editTaskStatus"]["request"]): void;
}

function useTaskStatusEdition(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isTaskStatusEditionRequestPending),
    isRequestSuccess: useSelector(selector.isTaskStatusEditionRequestSuccess),
    isRequestFailure: useSelector(selector.isTaskStatusEditionRequestFailure),
    editTaskStatus: core.editTaskStatus,
  };
}

export { useTaskStatusEdition };
